// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../duplicate-pin-plate/state/criteria';
import actions from '../../actions-list';

const updateDuplicatePinPlateCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const reset = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DUPLICATE_PIN_PLATE_CRITERIA]: reset,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_CRITERIA]: updateDuplicatePinPlateCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/reducers/criteria.js